import { render, staticRenderFns } from "./rouletteBonus.vue?vue&type=template&id=24ccb1e1&scoped=true"
import script from "./rouletteBonus.vue?vue&type=script&lang=js"
export * from "./rouletteBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ccb1e1",
  null
  
)

export default component.exports